import { ChangeEvent, useState } from 'react';
import styled, { css } from 'styled-components';

import useDevice from '@hooks/useDevice';
import { Input } from '@components/atoms';
import { device } from '@styles/mediaQuery';
import { RadioButton } from '@components/atoms';
import { FormJoin } from '@shared/interfaces/form';
import { PhoneNumberInput } from '@components/molecules';
import { joinFormInitial } from '@shared/constants/form';
import GetStartedBtn from '@components/molecules/GetStartedBtn';
import { validateAndFormatDate } from '@utils/date';

function JoinForm() {
  const { isDesktop } = useDevice();
  const [formData, setFormData] = useState<FormJoin>(joinFormInitial);

  const onChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [target.id]: target.value });
  };

  const handleDateOfBirth = ({ target }: ChangeEvent<HTMLInputElement>) => {
    const { isValid } = validateAndFormatDate(target.value);

    if (isValid) setFormData({ ...formData, [target.id]: target.value });
  };

  return (
    <Wrapper>
      <FullName>
        <Input
          id="firstName"
          value={formData.firstName}
          label="First Name"
          placeholder="First Name"
          required
          onChange={onChange}
          maxWidth={!isDesktop ? '566px' : '275px'}
        />

        <Input
          id="lastName"
          value={formData.lastName}
          label="Last Name"
          placeholder="Last Name"
          required
          onChange={onChange}
          maxWidth={!isDesktop ? '566px' : '275px'}
        />
      </FullName>

      <Input
        id="dateOfBirth"
        value={formData.dateOfBirth}
        label="Date of Birth"
        placeholder="Date in MM-DD-YYYY format"
        onChange={handleDateOfBirth}
        maxWidth="566px"
        required
      />

      <PhoneNumberInput
        object={formData}
        objectKey="phoneNumber"
        setPhoneNumber={setFormData}
        required
        phoneValue={formData.phoneNumber}
        maxWidth="566px"
      />

      <Input
        id="email"
        value={formData.email}
        label="Email"
        placeholder="namesurname@gmail.com"
        required
        onChange={onChange}
        maxWidth="566px"
      />

      <Input
        id="country"
        value={formData.country}
        label="Country"
        placeholder="United States"
        required
        onChange={onChange}
        maxWidth="566px"
      />

      <Input
        id="state"
        value={formData.state}
        label="State"
        placeholder="State"
        onChange={onChange}
        maxWidth="566px"
        required
      />

      <Input
        id="postalCode"
        value={formData.postalCode}
        label="Postal Code"
        placeholder="State"
        required
        onChange={onChange}
        maxWidth="566px"
      />

      <RadioButton
        formData={formData}
        id="hazmatPermit"
        value={formData.hazmatPermit}
        label="Do you have a hazmat permit?"
        required
        setFormData={setFormData}
        maxWidth="566px"
      />

      <GetStartedBtn formData={formData} notRequiredKeys={[]} />
    </Wrapper>
  );
}

const FullName = styled.div`
  width: 100%;
  max-width: 566px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  ${device.laptopL(css`
    flex-direction: row;
    justify-content: space-between;
  `)}
`;

const Wrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 630px;

  margin: 30px auto;

  ${device.laptopL(css`
    width: 60%;
    align-items: center;
  `)}
`;

export default JoinForm;
